import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import AssetModuleNavbar from "./AssetModuleNavbar";
import API_BASE_URL from "../config";

const REPORTS = [
  {
    title: "Asset Register",
    description: "Complete list of assets with ownership and location context.",
    endpoint: "/api/assets/reports/register",
    icon: "bi-journal-text",
  },
  {
    title: "Depreciation Schedule",
    description: "Book value and useful life view for finance reconciliation.",
    endpoint: "/api/assets/reports/depreciation",
    icon: "bi-graph-down",
  },
  {
    title: "Employee-wise Summary",
    description: "Current allocations grouped by employee and department.",
    endpoint: "/api/assets/reports/employee-wise",
    icon: "bi-people",
  },
  {
    title: "Expiring Warranty",
    description: "Assets nearing warranty expiry for renewals and action.",
    endpoint: "/api/assets/reports/expiring-warranty",
    icon: "bi-shield-exclamation",
  },
  {
    title: "Asset Requests",
    description: "All employee asset requests with priority, status and admin remarks.",
    endpoint: "/api/assets/reports/asset-requests",
    icon: "bi-clipboard2-plus",
  },
];

export default function AssetReportsPage() {
  const navigate = useNavigate();
  const [downloading, setDownloading] = useState("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    const bootstrapLink = document.createElement("link");
    bootstrapLink.rel = "stylesheet";
    bootstrapLink.href =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
    document.head.appendChild(bootstrapLink);

    const iconsLink = document.createElement("link");
    iconsLink.rel = "stylesheet";
    iconsLink.href =
      "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css";
    document.head.appendChild(iconsLink);

    return () => {
      bootstrapLink.remove();
      iconsLink.remove();
    };
  }, []);

  useEffect(() => {
    const roles = JSON.parse(localStorage.getItem("roles") || "[]");
    if (!token) {
      toast.error("You must be logged in.");
      navigate("/");
      return;
    }
    // if (!roles.includes("ROLE_ADMIN")) {
    //   toast.error("Unauthorized.");
    //   navigate("/");
    // }
  }, [navigate, token]);

  const handleDownload = async (report, format) => {
    try {
      setDownloading(`${report.title}-${format}`);
      const res = await fetch(`${API_BASE_URL}${report.endpoint}?format=${format}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Failed to download report.");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${report.title.replace(/\s+/g, "_")}.${format === "pdf" ? "pdf" : "xlsx"}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success(`${report.title} downloaded.`);
    } catch (err) {
      toast.error(err.message || "Unable to download report.");
    } finally {
      setDownloading("");
    }
  };

  return (
    <>
      <div className="fixed-top">
        <AssetModuleNavbar />
      </div>
      <div className="container-fluid my-4" style={{ paddingTop: "90px" }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h4 className="m-0">
              <i className="bi bi-bar-chart-line me-2"></i> Asset Reports
            </h4>
            <div className="text-muted mt-1" style={{ fontSize: 13 }}>
              Export operational and finance-facing views for compliance, tracking, and review.
            </div>
          </div>
          <button className="btn btn-outline-secondary btn-sm" onClick={() => navigate("/allassets")}>
            Asset List
          </button>
        </div>

        <div className="row g-3">
          {REPORTS.map((report) => (
            <div className="col-md-6" key={report.title}>
              <div className="bg-white border rounded p-4 h-100">
                <div className="d-flex align-items-start gap-3">
                  <div
                    className="d-flex align-items-center justify-content-center rounded"
                    style={{ width: 46, height: 46, background: "#e8f0f8", color: "#1e3a5f" }}
                  >
                    <i className={`bi ${report.icon}`} style={{ fontSize: 20 }}></i>
                  </div>
                  <div className="flex-grow-1">
                    <h5 className="mb-1">{report.title}</h5>
                    <p className="text-muted mb-3" style={{ fontSize: 14 }}>
                      {report.description}
                    </p>
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => handleDownload(report, "xlsx")}
                        disabled={downloading === `${report.title}-xlsx`}
                      >
                        {downloading === `${report.title}-xlsx` ? "Exporting..." : "Export Excel"}
                      </button>
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => handleDownload(report, "pdf")}
                        disabled={downloading === `${report.title}-pdf`}
                      >
                        {downloading === `${report.title}-pdf` ? "Exporting..." : "Export PDF"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
